export default {
  install: (Vue) => {
    Vue.prototype.$mixins = {
      checkQueryString(url) {
        try {
          const urlObject = new URL(url)
          return urlObject.searchParams.toString() !== ''
        } catch (e) {
          console.error(e)
          return false
        }
      },
      addQueryStrings(url, params) {
        try {
          const urlObject = new URL(url)

          Object.entries(params).forEach(([key, value]) => {
            urlObject.searchParams.set(key, value)
          })

          return urlObject.toString()
        } catch (e) {
          console.error(e)
          return url
        }
      },
      getQueryStringValue(url, key) {
        try {
          const urlObject = new URL(url)
          return urlObject.searchParams.get(key)
        } catch (e) {
          console.error(e)
          return null
        }
      },
      updateQueryString(url, key, newValue) {
        try {
          const urlObject = new URL(url)
          urlObject.searchParams.set(key, newValue)
          return urlObject.toString()
        } catch (e) {
          console.error(e)
          return url
        }
      },
    }
  },
}
